<!-- MOLECULE: OtpBalanceActions.vue -->

<script setup lang="ts">
//
// Imports
//

import AppBarActionButton from "./AppBarActionButton.vue";

//
// Composables
//

const { t } = useI18n();
const { triggerBalanceRefresh } = useOtpVisit();

// Share the same "otp-balance" key as the balance page — useState returns the
// same reactive ref, so loading reflects exactly what the page is doing.
const { loading } = useVisits("otp-balance");

//
// Computed
//

const isRefreshing = computed(() => loading.value);
</script>

<template>
  <app-bar-action-button
    icon="mdi-refresh"
    :tooltip-text="t('pages.otp-patient.balance.refresh.tooltip')"
    :loading="isRefreshing"
    :disabled="isRefreshing"
    @click="triggerBalanceRefresh"
  />
</template>
